import React from 'react';

import './Store.scss';

const Store = ({ setProductPosition }) => {
  return (
    <div id="fifth" className="Store">
      <div className="StoreTitle">Store</div>
      <div className="StoreMain">
        남산웍스의 TUF는 네이버 스마트스토어에서 구매하실 수 있습니다.
      </div>
      {/* <img className="StoreImage"></img> */}
      <a
        href="https://smartstore.naver.com/namsanworks"
        className="smartStoreATag"
        target="_blank"
        rel="noreferrer"
      >
        <button className="smartStoreButton">남산웍스 스토어 바로가기</button>
      </a>
    </div>

    // <input type="button" value="스토어 바로 가기" onclick="window.location.href='smartstore.naver.com/namsanworks'">
  );
};

export default Store;
